module.exports = __webpack_public_path__ + "media/img/help_center/Student_Academic_Profile_02-855bfb7f9194b6b52b67c1537df7d24d.jpg";